export const onHttpError = (err: any) => {
  if (err.response?.status === 403) window.location.href = '/forbidden'
  if (err.response?.status === 404) window.location.href = '/notFound'
}
